import type { FaireProductEntity } from "../../entity_types/product";

export const p_rhkx928vvd: FaireProductEntity = {
  token: "p_rhkx928vvd",
  type: "product",
  name: "Natural Vegan Eco Haircare Set for New Year with Rosemary",
  brandToken: "b_5402ufjv6k",
  brandName: "UpCircle USA",
  imageUrl:
    "https://cdn.faire.com/fastly/80570f894bf287d75c7b0408a1448222b37eb79515df5cde4fefd6a27e900fdc.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f2bb4195b472c9c9b8426eae930fbae92ced452ff134c9a570b579a8cc6932c3.jpeg",
    "https://cdn.faire.com/fastly/3efbe18c3f4a65e481dc7e178270e21b8548a7e251fc83b1c1746e4db16678bf.jpeg",
    "https://cdn.faire.com/fastly/a7f7ef7bb4ab9b961a87202e2ea0bb1c281d94526ec0f4540cfa60a68db2cd92.jpeg",
    "https://cdn.faire.com/fastly/258a6c84f3459159df1b7e21472b1cd2210ca6d844fd430bf783e5af1a24a868.jpeg",
    "https://cdn.faire.com/fastly/783252ed5cdcd3395d8559db67e20483653514d2eeb0c4b21e9172b7c327a9e3.jpeg",
    "https://cdn.faire.com/fastly/99296bcd4214f01ae5aab5403178026a2220147d04305063e1b9daf1efa65188.jpeg",
    "https://cdn.faire.com/fastly/cc5e80c277f912ae7bdf3a48c25b4552c833a057fb21b9cd020c56d3143a6c66.jpeg",
    "https://cdn.faire.com/fastly/af30701666dfea52e6d536067ac2c3ac29eb326854fbe1a2182a1d9d54a9ab93.jpeg",
    "https://cdn.faire.com/fastly/fedcd3fe08e17c5213aabd9eb441ebe81a5da224a3d60dc2fc34fc8d02e00c3a.jpeg",
    "https://cdn.faire.com/fastly/542299ed9104debfd1d494a923ca075fc51e881a90177be8dfbf37bc4c644022.jpeg",
    "https://cdn.faire.com/fastly/871e29d4bd6146940da97d173b2d834f39e0a22e4993f67c467d7a3d7ad2f853.jpeg",
    "https://cdn.faire.com/fastly/b3d990e9125fda9b0915e87d59f744e21233c047ba72d9c71f86eefffdd0e0be.jpeg",
    "https://cdn.faire.com/fastly/45e2a42e7820b382ef090e523b03f38d6b087cca4c2bfcdea4949e6a575b9eee.jpeg",
  ],
  priceDollars: 329.4,
  description:
    "The UpCircle haircare range is growing, and this dream routine delivers shine from scalp to ends. Features UpCircle bestsellers & two new launches. Includes a 10% b2b saving - this discount can then be passed on to your customers when sold as a bundle!\n\nIncludes:\n- 6 Haircare Duo (Shampoo Crème, 3.38 fl oz & Conditioner Crème, 3.38 fl oz)\n- 6 Hair Serum, 1.69 fl oz\n- 6 Scalp + Hair Oil, 1.69 fl oz\n- 6 Bamboo Comb\nFree POS including samples & testers\n\nOn the hunt for products that give hair that silky, nourished feel? Look no further! After trying this set, it's hard to go back.\n\n1 of each product in the bundle\nCosts you (with 10% off) - $54.90\nValue - $122\nSuggested MSRP with 20% off - $97.60\n\nAll products are vegan & cruelty-free, in recyclable packaging.\n\nUpCircle is the UK's #1 upcycled beauty brand, making sustainable products using natural ingredients that would otherwise go to waste.",
  tags: [],
  msrpDollars: 732,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:53:21.786Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
